
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire305e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire305e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $03cFT = parcelRequire("03cFT");

var $kcvY9 = parcelRequire("kcvY9");

var $cxph1 = parcelRequire("cxph1");

var $3w2h1 = parcelRequire("3w2h1");

var $3w2h1 = parcelRequire("3w2h1");

var $8jeb6 = parcelRequire("8jeb6");
"use strict";
window.Webflow ||= [];
window.Webflow.push(async ()=>{
    // ─────────────────────────────────────────
    // MARK: - CONSTANTS
    // ─────────────────────────────────────────
    const SCHOOL_DINING_OPTION_GUID = "ccbd65e7-efdd-40e3-95f8-82687c43b764";
    const CUTOFF_HOUR_DEFAULT = 9;
    const CUTOFF_MINUTE_DEFAULT = 0;
    const DELIVERY_FEE_GROUP_GUID = '7e1dbd1f-ec6d-4140-8b63-5a515b11a5e7';
    // ─────────────────────────────────────────
    // MARK: - ELEMENTS
    // ─────────────────────────────────────────
    const progressModal = document.getElementById('progressModal');
    const noStudentsDiv = document.getElementById('noStudentsDiv');
    const weekGridDiv = document.getElementById('weekGridDiv');
    const reviewOrdersButton = document.getElementById('reviewOrdersButton');
    const addStudentButton = document.getElementById('addStudentButton');
    const pastOrdersButton = document.getElementById('pastOrdersButton');
    // ─────────────────────────────────────────
    // MARK: - MENU MODAL ELEMENTS
    // Captured once at page load — before any DOM manipulation
    // ─────────────────────────────────────────
    const menuModal = document.getElementById('menuModal');
    const menuModalTitleLabel = document.getElementById('menuModalTitleLabel');
    const menuModalTotalLabel = document.getElementById('menuModalTotalLabel');
    const menuModalAddButton = document.getElementById('menuModalAddButton');
    const menuModalCloseButton = document.getElementById('menuModalCloseButton');
    const menuCategoryTabsDiv = document.getElementById('menuCategoryTabsDiv');
    const menuItemsDiv = document.getElementById('menuItemsDiv');
    const showingLabel = document.getElementById('showingLabel');
    // Save template cells BEFORE any innerHTML clearing can destroy them
    const menuItemTemplate = document.querySelector('[menuitem="cell"]').cloneNode(true);
    const categoryTabTemplate = document.querySelector('[category="tab"]').cloneNode(true);
    // ─────────────────────────────────────────
    // MARK: - STATE
    // ─────────────────────────────────────────
    var locationObject = await (0, $kcvY9.LocationObject)();
    if (locationObject?.get('schoolActive') === false) {
        alert('School lunch orders are temporarily unavailable. Please check back soon or call the store for assistance.');
        (0, $cxph1.goToNextPage)('/');
        return;
    }
    var students = [];
    var pendingOrders = [];
    var placedOrders = {};
    var daysOfWeek = [];
    var selectedStudent = null;
    var selectedDate = null;
    var selectedItems = [];
    var schoolLunchMenu = null;
    var schoolLunchCategories = [];
    var selectedCategoryIndex = 0;
    // ─────────────────────────────────────────
    // MARK: - WEEK SETUP
    // ─────────────────────────────────────────
    function setUpDates() {
        const now = new Date();
        const dayOfWeek = now.getDay();
        let monday;
        if (dayOfWeek === 6) {
            monday = new Date(now);
            monday.setDate(now.getDate() + 2);
        } else {
            const diff = dayOfWeek === 0 ? 1 : -(dayOfWeek - 1);
            monday = new Date(now);
            monday.setDate(now.getDate() + diff);
        }
        daysOfWeek = [];
        for(let i = 0; i < 5; i++){
            const day = new Date(monday);
            day.setDate(monday.getDate() + i);
            day.setHours(0, 0, 0, 0);
            daysOfWeek.push(day);
        }
    }
    // ─────────────────────────────────────────
    // MARK: - CUTOFF CHECK
    // ─────────────────────────────────────────
    function isBeyondCutoff(date) {
        const now = new Date();
        const cutoffHour = locationObject.get('schoolCutoffHour') ?? CUTOFF_HOUR_DEFAULT;
        const cutoffMinute = locationObject.get('schoolCutoffMinute') ?? CUTOFF_MINUTE_DEFAULT;
        const cutoff = new Date(date);
        cutoff.setHours(cutoffHour, cutoffMinute, 0, 0);
        return now > cutoff;
    }
    // ─────────────────────────────────────────
    // MARK: - TOAST SCHOOL MENU SETUP
    // ─────────────────────────────────────────
    async function loadSchoolLunchMenu() {
        const menu = sessionStorage.getItem("toastSchoolMenus");
        if (menu != null) {
            schoolLunchMenu = JSON.parse(menu);
            schoolLunchCategories = (0, $3w2h1.filterVisibility)(schoolLunchMenu.menuGroups ?? []);
            console.log('School lunch categories loaded:', schoolLunchCategories.length);
            return;
        }
        try {
            const toastGuid = "a1e195a2-fc65-46e4-b448-9661f48048ec";
            const parseMenu = await (0, $03cFT.default).Cloud.run('loadToastMenu', {
                'restaurantGuid': toastGuid
            });
            const toastMenuObject = parseMenu.get('object');
            (0, $3w2h1.storeSchoolMenuData)(toastMenuObject);
            const freshMenu = sessionStorage.getItem("toastSchoolMenus");
            if (freshMenu != null) {
                schoolLunchMenu = JSON.parse(freshMenu);
                schoolLunchCategories = (0, $3w2h1.filterVisibility)(schoolLunchMenu.menuGroups ?? []);
                console.log('School lunch categories loaded after fetch:', schoolLunchCategories.length);
            }
        } catch (e) {
            alert(e.message);
        }
    }
    // ─────────────────────────────────────────
    // MARK: - STUDENT LOADING
    // ─────────────────────────────────────────
    async function loadStudents() {
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser == null || currentUser.get('anonymous') == true) {
            const loginModal = document.getElementById('loginModal');
            if (loginModal) loginModal.style.display = 'flex';
            return;
        }
        progressModal.style.display = 'flex';
        try {
            const q = new (0, $03cFT.default).Query('Students');
            q.equalTo('userid', currentUser.id);
            q.include('school');
            const results = await q.find();
            students = results;
        } catch (e) {
            alert('Failed to load students: ' + e.message);
        }
        progressModal.style.display = 'none';
        if (students.length === 0) {
            noStudentsDiv.style.display = 'block';
            openStudentModal(null);
        } else {
            noStudentsDiv.style.display = 'none';
            await loadExistingOrders();
            await loadPlacedOrders();
            renderWeekGrid();
            checkForUpcomingOrders();
        }
    }
    // ─────────────────────────────────────────
    // MARK: - LOAD EXISTING ORDERS
    // ─────────────────────────────────────────
    async function loadExistingOrders() {
        // Orders are charged immediately on submission — no pending Parse records.
        // Restore any in-progress cart from sessionStorage (current session only).
        const sessionOrders = JSON.parse(sessionStorage.getItem('schoolPendingOrders')) ?? [];
        for (const sessionOrder of sessionOrders)pendingOrders.push({
            student: students.find((s)=>s.id === sessionOrder.studentid),
            studentid: sessionOrder.studentid,
            date: new Date(sessionOrder.dateISO),
            dateISO: sessionOrder.dateISO,
            items: sessionOrder.items,
            totalPrice: sessionOrder.totalPrice
        });
    }
    async function loadPlacedOrders() {
        const currentUser = (0, $03cFT.default).User.current();
        if (!currentUser || currentUser.get('anonymous')) return;
        const weekStart = daysOfWeek[0];
        const weekEnd = new Date(daysOfWeek[4]);
        weekEnd.setHours(23, 59, 59, 999);
        try {
            const q = new (0, $03cFT.default).Query('ToastSchoolOrders');
            q.equalTo('userid', currentUser.id);
            q.greaterThanOrEqualTo('ordertime', weekStart);
            q.lessThanOrEqualTo('ordertime', weekEnd);
            q.limit(100);
            const results = await q.find();
            placedOrders = {};
            for (const order of results){
                const ordertime = order.get('ordertime');
                const studentId = order.get('studentid');
                if (!ordertime || !studentId) continue;
                const dayStart = new Date(ordertime);
                dayStart.setHours(0, 0, 0, 0);
                const key = `${studentId}_${dayStart.getTime()}`;
                placedOrders[key] = {
                    price: order.get('totalprice') ?? 0,
                    count: (order.get('fooditemsJson') ?? []).length
                };
            }
        } catch (e) {
            console.error('loadPlacedOrders failed:', e.message);
        }
    }
    async function checkForUpcomingOrders() {
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser == null || currentUser.get('anonymous') == true) return;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const weekEnd = new Date(daysOfWeek[4]);
        weekEnd.setHours(23, 59, 59, 999);
        const lastWeekStart = new Date(daysOfWeek[0]);
        lastWeekStart.setDate(lastWeekStart.getDate() - 7);
        const lastWeekEnd = new Date(daysOfWeek[4]);
        lastWeekEnd.setDate(lastWeekEnd.getDate() - 7);
        lastWeekEnd.setHours(23, 59, 59, 999);
        try {
            const thisWeekQ = new (0, $03cFT.default).Query('ToastSchoolOrders');
            thisWeekQ.equalTo('userid', currentUser.id);
            thisWeekQ.greaterThanOrEqualTo('ordertime', today);
            thisWeekQ.lessThanOrEqualTo('ordertime', weekEnd);
            thisWeekQ.limit(1);
            const thisWeekCount = await thisWeekQ.count();
            if (thisWeekCount > 0) {
                if (confirm('You have orders placed for this week. Would you like to review them before placing new ones?')) (0, $cxph1.goToNextPage)('/school-lunch-past?upcoming=true');
                return;
            }
            const lastWeekQ = new (0, $03cFT.default).Query('ToastSchoolOrders');
            lastWeekQ.equalTo('userid', currentUser.id);
            lastWeekQ.greaterThanOrEqualTo('ordertime', lastWeekStart);
            lastWeekQ.lessThanOrEqualTo('ordertime', lastWeekEnd);
            lastWeekQ.limit(1);
            const lastWeekCount = await lastWeekQ.count();
            if (lastWeekCount > 0) // Future: offer reorder — for now just surface the info
            console.log('User has orders from last week available for reorder');
        } catch (e) {
            console.error('checkForUpcomingOrders failed:', e.message);
        }
    }
    // ─────────────────────────────────────────
    // MARK: - WEEK GRID RENDERING
    // ─────────────────────────────────────────
    function renderWeekGrid() {
        if (students.length === 0) return;
        weekGridDiv.style.display = 'block';
        setUpDayHeaders();
        const templateRow = document.querySelector('[student="row"]');
        const rowParent = templateRow.parentNode;
        for(let s = 0; s < students.length; s++){
            const student = students[s];
            const newRow = s === 0 ? templateRow : templateRow.cloneNode(true);
            if (s === 0) newRow.style.display = 'flex';
            const nameCell = newRow.querySelector('[student="nameCell"]');
            const fullname = student.get('fullname') ?? '';
            const school = student.get('school');
            const schoolName = school ? school.get('name') ?? '' : '';
            nameCell.innerText = fullname.toUpperCase() + '\n' + schoolName.toUpperCase();
            nameCell.addEventListener('click', ()=>openStudentModal(student));
            const dayCells = [
                ...newRow.querySelectorAll('[day="cell"]')
            ];
            for(let d = 0; d < 5; d++)renderDayCell(dayCells[d], student, daysOfWeek[d]);
            if (s !== 0) rowParent.appendChild(newRow);
        }
        updateReviewButton();
    }
    function setUpDayHeaders() {
        const headerCells = [
            ...document.querySelectorAll('[day="headerCell"]')
        ];
        const dayNames = [
            'MON',
            'TUE',
            'WED',
            'THU',
            'FRI'
        ];
        for(let i = 0; i < headerCells.length && i < 5; i++){
            const dayLabel = headerCells[i].querySelector('[day="headerDay"]');
            const dateLabel = headerCells[i].querySelector('[day="headerDate"]');
            if (dayLabel) dayLabel.innerText = dayNames[i];
            if (dateLabel) dateLabel.innerText = daysOfWeek[i].getDate();
        }
    }
    function renderDayCell(cell, student, date) {
        const dayLabel = cell.querySelector('[day="dayLabel"]');
        const dateLabel = cell.querySelector('[day="dateLabel"]');
        const orderInfo = cell.querySelector('[day="orderInfo"]');
        const itemCountLabel = cell.querySelector('[day="itemCountLabel"]');
        const priceLabel = cell.querySelector('[day="priceLabel"]');
        const cutoffOverlay = cell.querySelector('[day="cutoffOverlay"]');
        const clearButton = cell.querySelector('[day="clearButton"]');
        const dayNames = [
            'MON',
            'TUE',
            'WED',
            'THU',
            'FRI'
        ];
        const dayIndex = daysOfWeek.findIndex((d)=>isSameDay(d, date));
        if (dayLabel) dayLabel.innerText = dayNames[dayIndex] ?? '';
        if (dateLabel) dateLabel.innerText = date.getDate();
        // Reset state
        if (orderInfo) orderInfo.style.display = 'none';
        if (cutoffOverlay) cutoffOverlay.style.display = 'none';
        if (clearButton) clearButton.style.display = 'none';
        cell.style.backgroundColor = '';
        cell.onclick = null;
        const beyond = isBeyondCutoff(date);
        const existingOrder = getPendingOrder(student.id, date);
        const placedOrder = getPlacedOrder(student.id, date);
        if (placedOrder) {
            const count = placedOrder.count;
            if (itemCountLabel) itemCountLabel.innerText = count === 1 ? "1 Item \u2713" : `${count} Items \u{2713}`;
            if (priceLabel) priceLabel.innerText = $8jeb6(placedOrder.price).format();
            if (orderInfo) orderInfo.style.display = 'flex';
            cell.style.backgroundColor = 'rgba(52, 199, 89, 0.15)';
        } else if (beyond) {
            if (cutoffOverlay) cutoffOverlay.style.display = 'flex';
        } else {
            if (existingOrder) {
                const count = existingOrder.items.length;
                if (itemCountLabel) itemCountLabel.innerText = count === 1 ? '1 Item' : `${count} Items`;
                if (priceLabel) priceLabel.innerText = $8jeb6(existingOrder.totalPrice).format();
                if (orderInfo) orderInfo.style.display = 'flex';
                if (clearButton) {
                    clearButton.style.display = 'block';
                    clearButton.onclick = (e)=>{
                        e.stopPropagation();
                        clearOrder(student, date);
                    };
                }
            }
            cell.onclick = async ()=>{
                const error = checkValidDate(date, existingOrder);
                if (error !== '') {
                    alert(error);
                    return;
                }
                // Check for an already-placed order for this student on this date
                const dayStart = new Date(date);
                dayStart.setHours(0, 0, 0, 0);
                const dayEnd = new Date(date);
                dayEnd.setHours(23, 59, 59, 999);
                try {
                    const q = new (0, $03cFT.default).Query('ToastSchoolOrders');
                    q.equalTo('studentid', student.id);
                    q.greaterThanOrEqualTo('ordertime', dayStart);
                    q.lessThanOrEqualTo('ordertime', dayEnd);
                    q.limit(1);
                    const count = await q.count();
                    if (count > 0) {
                        alert('You already have an order for this student on this day');
                        return;
                    }
                } catch (e) {
                    console.error('Duplicate order check failed:', e.message);
                }
                selectedStudent = student;
                selectedDate = date;
                openMenuModal(existingOrder);
            };
        }
    }
    function checkValidDate(date, existingOrder) {
        const now = new Date();
        const day = date.getDate();
        const month = date.getMonth() + 1; // JS months are 0-indexed
        const year = date.getFullYear();
        let cutoffHour = 9;
        let cutoffMinute = 0;
        if (parent.locationObject) {
            cutoffHour = parent.locationObject.schoolCutoffHour ?? 9;
            cutoffMinute = parent.locationObject.schoolCutoffMinute ?? 0;
        }
        const cutoffDate = new Date(year, date.getMonth(), day, cutoffHour, cutoffMinute, 0);
        var error = "";
        if (now > cutoffDate) {
            const dateString = cutoffDate.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            });
            error = "School lunch orders close at " + dateString + " every day";
        }
        return error;
    }
    function getPendingOrder(studentId, date) {
        return pendingOrders.find((o)=>o.studentid === studentId && isSameDay(new Date(o.date), date));
    }
    function getPlacedOrder(studentId, date) {
        const dayStart = new Date(date);
        dayStart.setHours(0, 0, 0, 0);
        return placedOrders[`${studentId}_${dayStart.getTime()}`] ?? null;
    }
    function isSameDay(a, b) {
        return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }
    function clearOrder(student, date) {
        const index = pendingOrders.findIndex((o)=>o.studentid === student.id && isSameDay(new Date(o.date), date));
        if (index !== -1) pendingOrders.splice(index, 1);
        rerenderGrid();
    }
    function rerenderGrid() {
        const studentRows = [
            ...document.querySelectorAll('[student="row"]')
        ];
        for(let s = 0; s < studentRows.length && s < students.length; s++){
            const row = studentRows[s];
            const dayCells = [
                ...row.querySelectorAll('[day="cell"]')
            ];
            for(let d = 0; d < 5; d++)renderDayCell(dayCells[d], students[s], daysOfWeek[d]);
        }
        updateReviewButton();
    }
    function updateReviewButton() {
        reviewOrdersButton.style.display = pendingOrders.length > 0 ? 'block' : 'none';
    }
    // ─────────────────────────────────────────
    // MARK: - MENU MODAL
    // ─────────────────────────────────────────
    function openMenuModal(existingOrder) {
        selectedItems = existingOrder ? [
            ...existingOrder.items
        ] : [];
        selectedCategoryIndex = 0;
        const df = new Intl.DateTimeFormat('en-US', {
            weekday: 'short',
            month: '2-digit',
            day: '2-digit'
        });
        const dateString = df.format(selectedDate);
        const name = selectedStudent.get('fullname') ?? '';
        menuModalTitleLabel.innerText = `${name.toUpperCase()} \u{2014} ${dateString.toUpperCase()}`;
        menuModalAddButton.innerText = existingOrder ? 'UPDATE' : 'ADD';
        renderCategoryTabs();
        renderMenuItems(0);
        menuModal.style.display = 'flex';
    }
    function renderCategoryTabs() {
        menuCategoryTabsDiv.innerHTML = '';
        for(let i = 0; i < schoolLunchCategories.length; i++){
            const category = schoolLunchCategories[i];
            const tab = categoryTabTemplate.cloneNode(true);
            const tabLabel = tab.querySelector('[category="tabLabel"]');
            if (tabLabel) tabLabel.innerText = category.name.toUpperCase();
            tab.classList.toggle('tab-active', i === selectedCategoryIndex);
            const index = i; // capture for closure
            tab.onclick = ()=>{
                selectedCategoryIndex = index;
                showingLabel.innerText = "SELECT " + schoolLunchCategories[index].name.toUpperCase();
                renderCategoryTabs();
                renderMenuItems(index);
            };
            menuCategoryTabsDiv.appendChild(tab);
        }
    }
    function renderMenuItems(categoryIndex) {
        // Clear the list — safe because we use menuItemTemplate, not a live DOM query
        menuItemsDiv.innerHTML = '';
        const category = schoolLunchCategories[categoryIndex];
        if (!category) return;
        const items = (0, $3w2h1.filterVisibility)(category.menuItems ?? []);
        for(let i = 0; i < items.length; i++){
            const item = items[i];
            // Always clone from the saved template — never from the DOM
            const newCell = menuItemTemplate.cloneNode(true);
            const nameLabel = newCell.querySelector('[menuitem="nameLabel"]');
            const priceLabel = newCell.querySelector('[menuitem="priceLabel"]');
            const photo = newCell.querySelector('[menuitem="photo"]');
            const minusButton = newCell.querySelector('[menuitem="minusButton"]');
            const quantityLabel = newCell.querySelector('[menuitem="quantityLabel"]');
            const plusButton = newCell.querySelector('[menuitem="plusButton"]');
            if (nameLabel) nameLabel.innerText = item.name.toUpperCase();
            if (priceLabel) priceLabel.innerText = $8jeb6(item.price).format();
            if (photo) photo.style.display = 'none';
            updateMenuItemQuantityUI(newCell, item.guid);
            plusButton.addEventListener('click', ()=>{
                selectedItems.push({
                    guid: item.guid,
                    name: item.name,
                    price: item.price,
                    groupGuid: category.guid // carry group GUID for Toast order JSON
                });
                updateMenuItemQuantityUI(newCell, item.guid);
                updateMenuModalTotal();
            });
            minusButton.addEventListener('click', ()=>{
                const idx = selectedItems.findLastIndex((s)=>s.guid === item.guid);
                if (idx !== -1) selectedItems.splice(idx, 1);
                updateMenuItemQuantityUI(newCell, item.guid);
                updateMenuModalTotal();
            });
            menuItemsDiv.appendChild(newCell);
        }
        updateMenuModalTotal();
    }
    function updateMenuItemQuantityUI(cell, guid) {
        const quantityLabel = cell.querySelector('[menuitem="quantityLabel"]');
        const minusButton = cell.querySelector('[menuitem="minusButton"]');
        const count = selectedItems.filter((s)=>s.guid === guid).length;
        if (quantityLabel) quantityLabel.innerText = count > 0 ? `${count}` : '';
        if (minusButton) minusButton.style.display = count > 0 ? 'block' : 'none';
    }
    function updateMenuModalTotal() {
        const total = selectedItems.reduce((sum, item)=>sum + (item.price ?? 0), 0);
        menuModalTotalLabel.innerText = selectedItems.length > 0 ? 'TOTAL: ' + $8jeb6(total).format() : 'Choose items';
        menuModalAddButton.style.display = selectedItems.length > 0 ? 'block' : 'none';
    }
    menuModalAddButton.addEventListener('click', ()=>{
        if (selectedItems.length === 0) {
            alert('Please choose at least one item');
            return;
        }
        const total = selectedItems.reduce((sum, item)=>sum + (item.price ?? 0), 0);
        const totalString = $8jeb6(total).format();
        const existingIndex = pendingOrders.findIndex((o)=>o.studentid === selectedStudent.id && isSameDay(new Date(o.date), selectedDate));
        if (existingIndex !== -1) pendingOrders.splice(existingIndex, 1);
        pendingOrders.push({
            student: selectedStudent,
            studentid: selectedStudent.id,
            date: selectedDate,
            dateISO: selectedDate.toISOString(),
            items: [
                ...selectedItems
            ],
            totalPrice: totalString
        });
        closeMenuModal();
        rerenderGrid();
    });
    menuModalCloseButton.addEventListener('click', closeMenuModal);
    function closeMenuModal() {
        menuModal.style.display = 'none';
        selectedItems = [];
        selectedCategoryIndex = 0;
        selectedStudent = null;
        selectedDate = null;
    }
    // ─────────────────────────────────────────
    // MARK: - STUDENT MODAL
    // ─────────────────────────────────────────
    const studentModal = document.getElementById('studentModal');
    const studentModalTitleLabel = document.getElementById('studentModalTitleLabel');
    const studentNameInput = document.getElementById('studentNameInput');
    const studentGradeInput = document.getElementById('studentGradeInput');
    const studentLunchTimeInput = document.getElementById('studentLunchTimeInput');
    const chooseSchoolButton = document.getElementById('chooseSchoolButton');
    const saveStudentButton = document.getElementById('saveStudentButton');
    const deleteStudentButton = document.getElementById('deleteStudentButton');
    const studentModalCloseButton = document.getElementById('studentModalCloseButton');
    const schoolPickerModal = document.getElementById('schoolPickerModal');
    const schoolPickerCloseButton = document.getElementById('schoolPickerCloseButton');
    var editingStudent = null;
    var selectedSchool = null;
    var schools = [];
    function openStudentModal(student) {
        editingStudent = student;
        selectedSchool = null;
        if (student) {
            studentModalTitleLabel.innerText = 'EDIT STUDENT';
            studentNameInput.value = student.get('fullname') ?? '';
            studentGradeInput.value = student.get('grade') ?? '';
            const school = student.get('school');
            if (school) {
                selectedSchool = school;
                chooseSchoolButton.innerText = school.get('name') ?? 'Choose School';
            } else chooseSchoolButton.innerText = 'Choose School';
            const lunchtime = student.get('lunchtime');
            if (lunchtime) {
                const h = lunchtime.getHours().toString().padStart(2, '0');
                const m = lunchtime.getMinutes().toString().padStart(2, '0');
                studentLunchTimeInput.value = `${h}:${m}`;
            }
            deleteStudentButton.style.display = 'block';
            saveStudentButton.innerText = 'UPDATE';
        } else {
            studentModalTitleLabel.innerText = 'ADD STUDENT';
            studentNameInput.value = '';
            studentGradeInput.value = '';
            studentLunchTimeInput.value = '11:30';
            chooseSchoolButton.innerText = 'Choose School';
            deleteStudentButton.style.display = 'none';
            saveStudentButton.innerText = 'ADD';
        }
        studentModal.style.display = 'flex';
    }
    chooseSchoolButton.addEventListener('click', ()=>openSchoolPicker());
    studentModalCloseButton.addEventListener('click', ()=>closeStudentModal());
    function closeStudentModal() {
        studentModal.style.display = 'none';
        editingStudent = null;
        selectedSchool = null;
    }
    saveStudentButton.addEventListener('click', async ()=>{
        const name = studentNameInput.value.trim();
        const grade = studentGradeInput.value.trim();
        const lunchTimeValue = studentLunchTimeInput.value;
        let error = '';
        if (name.split(/\s+/).filter(Boolean).length < 2) error = 'Full name required (first and last)';
        if (grade === '') error = 'Grade required';
        if (!selectedSchool) error = 'Please choose a school';
        if (lunchTimeValue === '') error = 'Lunch time required';
        if (error !== '') {
            alert(error);
            return;
        }
        const [h, m] = lunchTimeValue.split(':').map(Number);
        const lunchtime = new Date();
        lunchtime.setHours(h, m, 0, 0);
        const df = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
        const lunchperiod = df.format(lunchtime);
        progressModal.style.display = 'flex';
        try {
            const currentUser = (0, $03cFT.default).User.current();
            let studentObj;
            if (editingStudent) studentObj = editingStudent;
            else {
                studentObj = new (0, $03cFT.default).Object('Students');
                studentObj.set('userid', currentUser.id);
            }
            studentObj.set('fullname', name);
            studentObj.set('grade', grade);
            studentObj.set('school', selectedSchool);
            studentObj.set('lunchtime', lunchtime);
            studentObj.set('lunchperiod', lunchperiod);
            await studentObj.save();
            if (!editingStudent) students.push(studentObj);
            closeStudentModal();
            if (students.length > 0) {
                weekGridDiv.style.display = 'block';
                noStudentsDiv.style.display = 'none';
                if (!editingStudent) window.location.reload();
                else rerenderGrid();
            }
        } catch (e) {
            alert('Save failed: ' + e.message);
        }
        progressModal.style.display = 'none';
    });
    deleteStudentButton.addEventListener('click', async ()=>{
        if (!editingStudent) return;
        if (!confirm('Delete this student? Any upcoming unpaid orders will need to be cancelled separately.')) return;
        progressModal.style.display = 'flex';
        try {
            await editingStudent.destroy();
            closeStudentModal();
            window.location.reload();
        } catch (e) {
            alert('Delete failed: ' + e.message);
        }
        progressModal.style.display = 'none';
    });
    // ─────────────────────────────────────────
    // MARK: - SCHOOL PICKER
    // ─────────────────────────────────────────
    async function openSchoolPicker() {
        if (schools.length === 0) {
            progressModal.style.display = 'flex';
            try {
                const q = new (0, $03cFT.default).Query('Schools');
                q.equalTo('show', true);
                schools = await q.find();
            } catch (e) {
                alert('Failed to load schools: ' + e.message);
            }
            progressModal.style.display = 'none';
        }
        renderSchoolList();
        schoolPickerModal.style.display = 'flex';
    }
    function renderSchoolList() {
        const templateCell = document.querySelector('[school="cell"]');
        const cellParent = templateCell.parentNode;
        const existingCells = [
            ...cellParent.querySelectorAll('[school="cell"]')
        ];
        existingCells.forEach((cell, i)=>{
            if (i !== 0) cell.remove();
        });
        for(let i = 0; i < schools.length; i++){
            const school = schools[i];
            const newCell = i === 0 ? existingCells[0] : existingCells[0].cloneNode(true);
            const nameLabel = newCell.querySelector('[school="nameLabel"]');
            const addressLabel = newCell.querySelector('[school="addressLabel"]');
            const photo = newCell.querySelector('[school="photo"]');
            if (nameLabel) nameLabel.innerText = school.get('name') ?? '';
            if (addressLabel) addressLabel.innerText = school.get('address') ?? '';
            addressLabel.style.display = "none";
            const photoFile = school.get('photo');
            if (photo && photoFile) {
                photo.src = photoFile.url();
                //photo.style.display = 'block';
                photo.style.display = 'none';
            } else if (photo) photo.style.display = 'none';
            newCell.onclick = ()=>{
                selectedSchool = school;
                chooseSchoolButton.innerText = school.get('name') ?? 'School';
                schoolPickerModal.style.display = 'none';
            };
            if (i !== 0) cellParent.appendChild(newCell);
        }
    }
    schoolPickerCloseButton.addEventListener('click', ()=>{
        schoolPickerModal.style.display = 'none';
    });
    // ─────────────────────────────────────────
    // MARK: - REVIEW BUTTON & NAVIGATION
    // ─────────────────────────────────────────
    reviewOrdersButton.addEventListener('click', ()=>{
        if (pendingOrders.length === 0) {
            alert('No orders to review');
            return;
        }
        const serialized = pendingOrders.map((o)=>({
                studentid: o.studentid,
                studentName: o.student.get('fullname') ?? '',
                schoolName: o.student.get('school')?.get('name') ?? '',
                schoolObjectId: o.student.get('school')?.id ?? '',
                grade: o.student.get('grade') ?? '',
                lunchperiod: o.student.get('lunchperiod') ?? '',
                dateISO: o.dateISO,
                items: o.items,
                totalPrice: o.totalPrice
            }));
        sessionStorage.setItem('schoolPendingOrders', JSON.stringify(serialized));
        (0, $cxph1.goToNextPage)('/school-lunch-review');
    });
    addStudentButton.addEventListener('click', ()=>openStudentModal(null));
    pastOrdersButton.addEventListener('click', ()=>(0, $cxph1.goToNextPage)('/school-lunch-past'));
    // ─────────────────────────────────────────
    // MARK: - INIT
    // ─────────────────────────────────────────
    setUpDates();
    await loadSchoolLunchMenu();
    await loadStudents();
});


//# sourceMappingURL=school-lunch.2c6d43e8.js.map
